export enum API {
  USER_GET_ONE = '/user/:id',
  LOGIN = '/auth/login',
  ME = '/v1/auth/me',
  PROJECTS_GET_ALL = '/crud/projects',
  PROJECT_GET_ONE = '/crud/projects/:id',
  PROJECT_DELETE = '/crud/projects/:id',
  PROJECT_EDIT = '/crud/projects/:id',
  PROJECT_CREATE = '/crud/projects',
};